import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ToastrModule } from 'ngx-toastr';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule, MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';


import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';

import { MenuStatsComponent } from './header/menu-stats/menu-stats.component';

import { ChatComponent } from '../chat/chat.component';
import { ContactSupportComponent } from '../contact-support/contact-support.component';

import { EmojiPipe } from '../core//pipe/emoji.pipe';
import { RelativeTimePipe } from '../core/pipe/relativeTime.pipe';
import { I18nPipe } from '../core/pipe/i18n.pipe';
import { HoverPopUpDirective } from '../core/directives/hover-pop-up.directive';
import { CurrencyNumberPipe, DecimalNumberPipe } from '../core/pipe/decimalNumber.pipe';
import { ResultDialogComponent } from './result-dialog/result-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { SnackbarMessageComponent } from './snackbar-message/snackbar-message';
import { WarningBoxComponent } from './warning-box/warning-box.component';
import { EarnPortalComponent } from '../balances/currency-management/earn-portal/earn-portal.component';
import {
  ProductConfirmationComponent
} from '../balances/currency-management/earn-portal/product-confirmation/product-confirmation.component';
import { LinkAccountDialogComponent } from '../balances/link-account-dialog/link-account-dialog.component';
import { MarketCoinsComponent } from '../home/market-coins/market-coins.component';
import { BalanceViewerComponent } from './balance-viewer/balance-viewer.component';
import { ExplorerUrlPipe } from '../core/pipe/explorerUrl.pipe';
import { CoinAnalyticsComponent } from '../markets/coin-analytics/coin-analytics.component';
import { TopStatsComponent } from '../markets/chart/top-stats/top-stats.component';
import { CommentCardComponent } from './comment-card/comment-card.component';
import { TokenInputComponent } from './token-input/token-input.component';
import { AuthGuard, NoAuthGuard } from '../core/services/auth-guard.service';
import { DomainDialogComponent } from './domain-dialog/domain-dialog.component';
import { LivenessCheckComponent } from './liveness-check/liveness-check.component';
import { BalanceCardsComponent } from '../balances/balance-cards/balance-cards.component';
import { BalanceCardComponent } from '../balances/balance-cards/balance-card/balance-card.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MatButtonModule,
        MatMenuModule,
        MatSidenavModule,
        MatSelectModule,
        MatToolbarModule,
        MatListModule,
        MatIconModule,
        MatTableModule,
        MatTabsModule,
        MatTooltipModule,
        MatInputModule,
        MatPaginatorModule,
        MatCardModule,
        MatSortModule,
        MatExpansionModule,
        MatGridListModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        MatSlideToggleModule,
        MatAutocompleteModule,
        ToastrModule.forRoot({
            positionClass: 'toast-top-right',
            timeOut: 10000,
            preventDuplicates: true,
            maxOpened: 5,
            autoDismiss: true,
            progressBar: true,
            progressAnimation: 'decreasing',
            closeButton: true,
            enableHtml: true
        }),
    ],
    declarations: [
        EmojiPipe,
        CommentCardComponent,
        RelativeTimePipe,
        I18nPipe,
        ExplorerUrlPipe,
        HeaderComponent,
        FooterComponent,
        ChatComponent,
        ContactSupportComponent,
        HoverPopUpDirective,
        DecimalNumberPipe,
        CurrencyNumberPipe,
        ResultDialogComponent,
        ConfirmDialogComponent,
        SnackbarMessageComponent,
        WarningBoxComponent,
        MenuStatsComponent,
        EarnPortalComponent,
        BalanceCardsComponent,
        BalanceCardComponent,
        ProductConfirmationComponent,
        LinkAccountDialogComponent,
        MarketCoinsComponent,
        BalanceViewerComponent,
        CoinAnalyticsComponent,
        TopStatsComponent,
        TokenInputComponent,
        DomainDialogComponent,
        LivenessCheckComponent
    ],
    exports: [
        HeaderComponent,
        FooterComponent,
        I18nPipe,
        ExplorerUrlPipe,
        EmojiPipe,
        RelativeTimePipe,
        ChatComponent,
        ContactSupportComponent,
        CoinAnalyticsComponent,
        HoverPopUpDirective,
        DecimalNumberPipe,
        MenuStatsComponent,
        WarningBoxComponent,
        CurrencyNumberPipe,
        MarketCoinsComponent,
        BalanceViewerComponent,
        MatTooltipModule,
        MatProgressSpinnerModule,
        TopStatsComponent,
        MatSlideToggleModule,
        CommentCardComponent,
        EarnPortalComponent,
        BalanceCardsComponent,
        BalanceCardComponent,
        TokenInputComponent,
        ReactiveFormsModule,
        LivenessCheckComponent
    ],
    providers: [
        AuthGuard,
        NoAuthGuard,
    ]
})
export class SharedModule { }
